import { useEffect, useState } from 'react';

export type LeadOpsMode = 'publisher' | 'advertiser' | 'unsold';

const STORAGE_KEY = 'leadops_mode';
const DEFAULT_MODE: LeadOpsMode = 'advertiser';

const isMode = (value: unknown): value is LeadOpsMode =>
  value === 'publisher' || value === 'advertiser' || value === 'unsold';

export const useLeadOpsMode = () => {
  const [mode, setMode] = useState<LeadOpsMode>(DEFAULT_MODE);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (isMode(saved)) setMode(saved);
    } catch {
      // localStorage disabled
    }
  }, []);

  const changeMode = (next: LeadOpsMode) => {
    setMode(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore
    }
  };

  return {
    mode,
    changeMode,
    isPublisher: mode === 'publisher',
    isUnsold: mode === 'unsold',
  };
};
